@if (!allSet) {
  <div class="loading">
    <img
      src="./assets/images/boat-loading.gif"
      alt="loading sell process"
      class="loading-image"
      />
      <h1 class="loading-title">
        Reach NZ's largest motor audience.
      </h1>
    </div>
  }
  @if (allSet) {
    <router-outlet></router-outlet>
  }
